<template>
  <div
    cols="12"
    lg="12"
    md="12"
  >
    <PersonalInformation
      v-if="activeIndex === 1"
      :accountType="accountType"
      :birthday="date"
      :firstName="firstName"
      :lastName="lastName"
      :selectedCountry="selectedCountry"
      @handleClickNext="activeIndex += 1"
      @handleClickSkip="activeIndex += 1"
    />
    <UploadFiles
      v-if="showUploadFiles && activeIndex === 2"
      @handleClickBack="activeIndex -= 1"
      @handleClickNext="activeIndex += 1"
      @handleClickSkip="activeIndex += 1"
    />
    <ChooseGrades
      v-if="activeIndex === subjectsIndex"
      :selectedSubjects="selectedSubjects"
      :subjects="subjects"
      @handleClickBack="activeIndex -= 1"
    />
  </div>
</template>

<script>
import google from "@/assets/google.png";
import Logo from "@/assets/guiomentorLogo.png";
import { mapGetters } from "vuex";
import countries from "@/constants/countries.json";
import PersonalInformation from "./Personal-Information.vue";
import ChooseGrades from "./Grades";
import UploadFiles from "@/components/UploadFiles";
import IsAuthenticatedMixin from "@/mixins/IsAuthenticatedMixin";
import HasAccountTypeAndUSerExistsMixin from "@/mixins/HasAccountTypeAndUSerExistsMixin";

export default {
  mixins: [IsAuthenticatedMixin, HasAccountTypeAndUSerExistsMixin],
  components: {
    UploadFiles,
    PersonalInformation,
    ChooseGrades,
  },
  metaInfo() {
    return {
      title: "Guiomentor - User On-boarding",
      url: window.location.href
    };
  },
  data() {
    return {
      google,
      Logo,
      email: "",
      password: "",
      loading: false,
      firstName: "",
      lastName: "",
      countries,
      selectedCountry: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      phone: null,
      activeIndex: 1,
      subjects: [],
      selectedSubjects: [],
      accountType: [],
    };
  },
  methods: {},
  computed: {
    ...mapGetters({
      user: "auth/GET_USER",
      profile: "auth/GET_USER_PROFILE",
    }),
    showUploadFiles() {
      return this.user.account_types?.filter((item) => item.name === "MENTOR").length;
    },
    subjectsIndex() {
      return this.showUploadFiles ? 3 : 2;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.signup__container {
  height: 100vh;

  .row {
    margin: 0;
  }
}

.left {
  height: 100vh;
  margin-top: 0;
  margin-bottom: 0;
  background: #0033AA;

  .logo {
    width: 130px;
    height: 130px;
  }
}

.right {
  background: #f5f6f8;
  height: 100vh;
}
</style>
